import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  licensePermissions: [],
};

export const LicenseManagementSlice = createSlice({
  name: "LicenseManagement",
  initialState,
  reducers: {
    updateLicenseData: (state, action) => {
      const { type, value } = action.payload;
      state[type] = value;
    },
  },
});

export const { updateLicenseData } = LicenseManagementSlice.actions;

export default LicenseManagementSlice.reducer;
